/** The image a layer uses on a given size — the per-size override, else the shared one. */
export function layerImageAt(layer, sizeId) {
  if (layer.imageBySize && sizeId in layer.imageBySize) return layer.imageBySize[sizeId];
  return layer.imageSource ?? null;
}

/** A layer's stacking order on a given size — the per-size override, else the shared z. */
export function layerZAt(layer, sizeId) {
  if (layer.zBySize && sizeId in layer.zBySize) return layer.zBySize[sizeId];
  return layer.z;
}